import {BandDto} from "./band.interface";
import {Api} from "../../common/api/Api";

export async function getBands(): Promise<BandDto[]> {
  return Api.get<BandDto[]>("/bands").then(resp => resp.data)
}
